import styled from "styled-components";

export const Container = styled.div`
    background: var(--header-color);
    height: auto;
    border-bottom-left-radius: 50px;
    padding: 40px 0 100px 0;
`;
